import {
  U_SUM,
  U_KEY,
  U_DIRECTION,
  U_SHARE_OF_TOTAL_AMOUNT,
  U_FOR_A_PERIOD,
  U_PERFORMANCE,
  U_LAG,
  U_QUANTITY,
  U_AVERAGE_CHECK,
  U_QUANTITY_1,
  U_AVERAGE_CHECK_1,
  U_AMOUNT_2,
  U_AMOUNT_3,
  U_QUANTITY_IN_BRANCH,
} from '@app/constants';
import type { NAnalytics } from '@app/types/Analytics';
import { divideAmount } from '@app/utils';

import { FINALLY } from '@pages/Analytics/DirectionsIndicatorsList/constants/categories';

export const adaptDataToTable = (
  analyticsServiceCategories:
    | NAnalytics.ModelAnalyticsServiceCategories
    | undefined
) => {
  return analyticsServiceCategories?.Categories
    ? analyticsServiceCategories.Categories.map(
        (payment: NAnalytics.Category, index: number) => {
          const {
            CategoryId,
            CategoryName,
            Price,
            PercentagePrice,
            SalePlans,
            FirstClients,
            SecondClients,
          } = payment;

          const rowKey = `${CategoryId ?? 'category'}-${
            CategoryName ?? 'empty'
          }-${index}`;

          return {
            [U_KEY]: rowKey,
            [U_DIRECTION]: (
              <div
                style={{
                  fontWeight: CategoryName === FINALLY ? '600' : '400',
                  minWidth: '190px',
                }}
              >
                {CategoryName}
              </div>
            ),
            [U_SUM]: (
              <div
                style={{
                  minWidth: '130px',
                  fontWeight: CategoryName === FINALLY ? '600' : '400',
                }}
              >
                {Price && divideAmount(Number(Price.toFixed(2)))}
              </div>
            ),
            [U_SHARE_OF_TOTAL_AMOUNT]: (
              <div
                style={{
                  minWidth: '110px',
                  fontWeight: CategoryName === FINALLY ? '600' : '400',
                }}
              >
                {PercentagePrice &&
                  divideAmount(Number(PercentagePrice.toFixed(2)))}
              </div>
            ),
            [U_FOR_A_PERIOD]: (
              <div
                style={{
                  minWidth: '130px',
                  fontWeight: CategoryName === FINALLY ? '600' : '400',
                }}
              >
                {SalePlans?.Plan &&
                  divideAmount(Number(SalePlans?.Plan.toFixed(2)))}
              </div>
            ),
            [U_PERFORMANCE]: (
              <div
                style={{
                  minWidth: '130px',
                  fontWeight: CategoryName === FINALLY ? '600' : '400',
                }}
              >
                {SalePlans?.PercentageCompletion &&
                  divideAmount(
                    Number(SalePlans?.PercentageCompletion.toFixed(2))
                  )}
              </div>
            ),
            [U_LAG]: (
              <div
                style={{
                  minWidth: '130px',
                  fontWeight: CategoryName === FINALLY ? '600' : '400',
                }}
              >
                {SalePlans?.Lag &&
                  divideAmount(Number(SalePlans?.Lag.toFixed(2)))}
              </div>
            ),
            [U_QUANTITY]: (
              <div
                style={{
                  minWidth: '130px',
                  fontWeight: CategoryName === FINALLY ? '600' : '400',
                }}
              >
                {FirstClients?.Count &&
                  divideAmount(Number(FirstClients?.Count.toFixed(2)))}
              </div>
            ),
            [U_QUANTITY_IN_BRANCH]: (
              <div
                style={{
                  minWidth: '130px',
                  fontWeight: CategoryName === FINALLY ? '600' : '400',
                }}
              >
                {FirstClients?.CountInBranch &&
                  divideAmount(Number(FirstClients?.CountInBranch.toFixed(2)))}
              </div>
            ),
            [U_AMOUNT_2]: (
              <div
                style={{
                  minWidth: '130px',
                  fontWeight: CategoryName === FINALLY ? '600' : '400',
                }}
              >
                {FirstClients?.Amount &&
                  divideAmount(Number(FirstClients?.Amount.toFixed(2)))}
              </div>
            ),
            [U_AVERAGE_CHECK]: (
              <div
                style={{
                  minWidth: '130px',
                  fontWeight: CategoryName === FINALLY ? '600' : '400',
                }}
              >
                {FirstClients?.AverageCheck &&
                  divideAmount(Number(FirstClients?.AverageCheck.toFixed(2)))}
              </div>
            ),
            [U_QUANTITY_1]: (
              <div
                style={{
                  minWidth: '130px',
                  fontWeight: CategoryName === FINALLY ? '600' : '400',
                }}
              >
                {SecondClients?.Count &&
                  divideAmount(Number(SecondClients?.Count.toFixed(2)))}
              </div>
            ),
            [U_AMOUNT_3]: (
              <div
                style={{
                  minWidth: '130px',
                  fontWeight: CategoryName === FINALLY ? '600' : '400',
                }}
              >
                {SecondClients?.Amount &&
                  divideAmount(Number(SecondClients?.Amount.toFixed(2)))}
              </div>
            ),
            [U_AVERAGE_CHECK_1]: (
              <div
                style={{
                  minWidth: '130px',
                  fontWeight: CategoryName === FINALLY ? '600' : '400',
                }}
              >
                {SecondClients?.AverageCheck &&
                  divideAmount(Number(SecondClients?.AverageCheck.toFixed(2)))}
              </div>
            ),
            // Скрыто в рамках таски task/5716. Оставляю на случай, если нужно будет вернуть
            // [U_QUANTITY_2]: (
            //   <div
            //     style={{
            //       minWidth: '130px',
            //       fontWeight: CategoryName === FINALLY ? '600' : '400',
            //     }}
            //   >
            //     {AdditionalSales?.In?.Count &&
            //       divideAmount(Number(AdditionalSales?.In?.Count.toFixed(2)))}
            //   </div>
            // ),
            // [U_AMOUNT]: (
            //   <div
            //     style={{
            //       minWidth: '130px',
            //       fontWeight: CategoryName === FINALLY ? '600' : '400',
            //     }}
            //   >
            //     {AdditionalSales?.In?.Price &&
            //       divideAmount(Number(AdditionalSales?.In?.Price.toFixed(2)))}
            //   </div>
            // ),
            // [U_QUANTITY_3]: (
            //   <div
            //     style={{
            //       minWidth: '130px',
            //       fontWeight: CategoryName === FINALLY ? '600' : '400',
            //     }}
            //   >
            //     {AdditionalSales?.Out?.Count &&
            //       divideAmount(Number(AdditionalSales?.Out?.Count.toFixed(2)))}
            //   </div>
            // ),
            // [U_AMOUNT_1]: (
            //   <div
            //     style={{
            //       minWidth: '130px',
            //       fontWeight: CategoryName === FINALLY ? '600' : '400',
            //     }}
            //   >
            //     {AdditionalSales?.Out?.Price &&
            //       divideAmount(Number(AdditionalSales?.Out?.Price.toFixed(2)))}
            //   </div>
            // ),
          };
        }
      )
    : undefined;
};
